import Component from '@glimmer/component';

interface CarouselItemSignature {
  Element: HTMLAnchorElement;
  Args: {
    href: string;
    imgSrc: string;
    alt: string;
    isNew?: boolean;
  };
  Blocks: {
    default: [];
  };
}

export default class CarouselItem extends Component<CarouselItemSignature> {
  constructor(owner: unknown, args: CarouselItemSignature['Args']) {
    super(owner, args);
  }

  get displayAlt() {
    let text = this.args.alt;

    // non breaking hyphens (so "drum-kins" is on one line)
    text = text.replace(/-/g, '\u2011');

    // non breaking space if "Vol. X"
    text = text.replace(/\b(vol\.)\s+(\d+)/gi, (_match, vol, num) => {
      return `${vol}\u00A0${num}`; 
    });

    return text;
  }

  <template>
    <a
      href={{@href}}
      target="_blank"
      rel="noopener noreferrer"
      data-carousel-item
      class="w-[148px] shrink-0 snap-start text-center"
      ...attributes
    >
      <div class="relative pt-2">
        {{#if @isNew}}
          <div
            class="absolute top-1 right-0 bg-yellow-400 text-black text-xs font-bold
                  px-2 py-0.5 rounded shadow"
          >
            NEW!
          </div>
        {{/if}}

        <img
          src={{@imgSrc}}
          alt={{@alt}}
          class="w-full aspect-square object-cover mt-2"
        />
      </div>

      <div class="mt-4 text-lg leading-snug dark:text-white">
        {{this.displayAlt}}
      </div>
    </a>
  </template>
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    CarouselItem: typeof CarouselItem;
  }
}
